import * as RestApi from 'core/network/RestApi';
import { useQuery } from 'react-query';

export function useGetCurrenciesQuery(siteId: string) {
  return useQuery(
    `/sites/${siteId}/reportabledata/currencies`,
    async () => await RestApi.get<string[]>(`/sites/${siteId}/reportabledata/currencies`),
  );
}
export function useGetSalesTotalsQuery(siteId: string, dateTime: string, queryString: string) {
  return useQuery(
    `/sites/${siteId}/reportabledata/${dateTime}/sales/totals${queryString}`,
    async () => await RestApi.get(`/sites/${siteId}/reportabledata/${dateTime}/sales/totals${queryString}`),
  );
}
